// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import NewStock from '../components/stocks/new_stock';
import TakeDelivery from "../components/purchaseorders/take_delivery";
import LineItem from '../components/purchaseorders/line_items';
import DeductStock from '../components/stocks/deduct_stock';
import ToastNotification from '../components/notifications.jsx';
import NewSpecial from '../components/specials/new_special';
import NewSpecialPack from '../components/specials/new_special_pack';
import ReserveStock from '../components/stocks/reserve_stock';
import FindRoll from '../components/stocks/find_roll';
import NewJobsheet from '../components/jobsheets/new_jobsheet';
import CutListForm from '../components/cutting_plan/cutlist';
import Sow from '../components/sow/sow';
import NewSpecialRoll from '../components/specials/new_special_roll';
import NewSalesLead from '../components/salesleads/new_saleslead';

const componentsToRender = {
  NewStock: NewStock,
  DeductStock: DeductStock,
  TakeDelivery: TakeDelivery,
  LineItem: LineItem,
  ToastNotification: ToastNotification,
  NewSpecial: NewSpecial,
  NewSpecialPack: NewSpecialPack,
  NewSpecialRoll: NewSpecialRoll,
  ReserveStock: ReserveStock,
  FindRoll: FindRoll,
  NewJobsheet: NewJobsheet,
  CutListForm: CutListForm,
  Sow: Sow,
  NewSalesLead: NewSalesLead
}

$(document).ready(function () {
  $('#table').DataTable({
    "order": []
  });
});



Object.entries(componentsToRender).forEach(([id, component]) => {
  const element = document.getElementById(id);

  if (element) {
    const root = ReactDOMClient.createRoot(element);
    root.render(React.createElement(component));
  }
})
